import { IAngularEvent, IPromise, IQService, IRootScopeService, IScope } from "angular";
import { StateService } from "@uirouter/angularjs";
import { IStateInit } from "@gtmhub/core/routing";
import { IIndicator } from "@gtmhub/error-handling";
import { FilterEvents } from "@gtmhub/hub/events";
import { IHubFilter } from "@gtmhub/hub/models/hub";
import { HubService } from "@gtmhub/hub/services/hub";
import { localize } from "@gtmhub/localization";
import { IGtmhubRootScopeService } from "@gtmhub/models";
import { IExtendedRootScopeService } from "@gtmhub/shared/ng-extensions";
import { Ng1ConfirmDeleteService } from "@gtmhub/shared/services/ng1-confirm-delete.service";
import { PageTitleService } from "@gtmhub/shared/services/page-title-service";
import { capitalize } from "@gtmhub/util";

interface ITaskFilterStateParams {
  filterId?: string;
}
interface ITaskFilterScope extends IScope, IExtendedRootScopeService {
  indicators: {
    deletingFilter?: IIndicator;
  };
  confirmDeleteFilter(filterId: string): void;
  editFilter(filterId: string): void;
  assignees: string[];

  filter: Pick<IHubFilter, "name">;
  params: ITaskFilterStateParams;
}

export class TaskFilterCtrl implements IStateInit {
  public static $inject = ["$rootScope", "$scope", "$state", "$stateParams", "HubService", "PageTitleService", "$q", "Ng1ConfirmDeleteService"];
  private filterEvents: FilterEvents;

  constructor(
    private $rootScope: IRootScopeService & IGtmhubRootScopeService,
    private $scope: ITaskFilterScope,
    private $state: StateService,
    private $stateParams: ITaskFilterStateParams,
    private hubService: HubService,
    private pageTitleService: PageTitleService,
    private $q: IQService,
    private confirmDeleteService: Ng1ConfirmDeleteService
  ) {
    this.$scope.indicators = {};
    this.$scope.params = { ...this.$stateParams };

    this.$scope.confirmDeleteFilter = this.confirmDeleteFilter;
    this.$scope.editFilter = this.editFilter;

    this.$scope.$on("filterChanged", (evt: IAngularEvent, filter: IHubFilter) => this.onFilterChanged(filter));
    this.filterEvents = new FilterEvents(this.$rootScope);
  }

  public stateInit(): IPromise<void> {
    if (this.$stateParams.filterId) {
      this.onLoadFilter(this.$stateParams.filterId);
    } else {
      this.onSetFakeFilter();
    }

    return this.$q.resolve();
  }

  private onLoadFilter = (filterId: string) => {
    this.hubService.getFilter(filterId).then((filter) => {
      if (!filter.teamIds) {
        filter.teamIds = [];
      }
      if (!filter.employeeIds) {
        filter.employeeIds = [];
      }

      this.$scope.assignees = filter.employeeIds.concat(filter.teamIds);
      this.$scope.filter = filter;
      this.pageTitleService.setPageTitle(`${this.$scope.filter.name}`);
    });
  };

  private onSetFakeFilter = () => {
    this.$scope.filter = { name: capitalize(localize("my_tasks")) };
    this.pageTitleService.setPageTitle(`${this.$scope.filter.name}`);
  };

  private onFilterChanged = (filter: IHubFilter) => {
    if (this.$scope.params.filterId && filter.id === this.$scope.params.filterId) {
      this.onLoadFilter(filter.id);
    }
  };

  private editFilter = (filterId: string) => {
    this.$state.go(this.$state.current.name + "._filter.filter", { formFilterId: filterId });
  };

  private deleteFilter = (filterId: string) => {
    if (!filterId) throw new Error("No filter with this id exists. Please try again!");

    this.$scope.indicators.deletingFilter = { progress: true };

    this.hubService.deleteFilter(filterId).then(
      () => {
        this.filterEvents.broadcastFiltersChanged({ filter: { id: filterId, name: "" }, action: "delete" });
        this.$state.go("gtmhub.tasks", { filterId: null });
        this.$scope.filter.name = "My Tasks";

        delete this.$scope.indicators.deletingFilter;
      },
      (error) => (this.$scope.indicators.deletingFilter = { error })
    );
  };

  private confirmDeleteFilter = (filterId: string) => {
    this.confirmDeleteService.confirmDeleteItem({ itemKey: "custom_view", itemToCase: true }).subscribe(() => this.deleteFilter(filterId));
  };
}
